import { Rank } from "@/modules/user/types/index.v2";

export interface QueryAgentTargetsDTO {
  organizationUId: string;
  userUId?: string;
  from: string;
  to: string;
  includeDirectReports?: boolean;
  userTree?: string[];
}

export interface QueryExtraAchievementsDTO {
  from: string;
  to: string;
  userUId: string;
}

export interface CreateExtraAchievementDTO {
  from: string;
  to: string;
  amount: number;
  userUId: string;
}

export interface MonthTargetDTO {
  id: number;
  from: Date;
  to: Date;
  personalTarget: number;
  personalAchievement: number;
  teamTarget: number;
  teamAchievement: number;
  targetAdjust: number;
  extraAchievement: number;
  effectiveTargetType?: string;
  userType: string; // Added userType field from API response
}

export enum UserType {
  MOVER = "mover",
  LEAVER = "leaver",
  NORMAL = "normal",
  JOINER = "joiner",
}

export interface TargetUserDTO {
  cognitoId: string;
  name: string;
  fullName: string;
  phone: string;
  banned: boolean;
  color?: string;
}

export interface AgentTargetDTO {
  user: TargetUserDTO;
  targets: MonthTargetDTO[];
  hasReports: boolean;
  directReports?: AgentTargetDTO[];
}

export interface ExtraAchievementDTO {
  id: number;
  from: string;
  to: string;
  amount: number;
  user: TargetUserDTO;
}

export interface Subordinate {
  uid: string;
  directSubordinates: number;
  totalSubordinates: number;
  name: string;
  color?: string;
  rank: Rank;
  subordinates: Subordinate[];
}

export interface MemberHierarchyResponseData {
  data: {
    uid: string;
    directSubordinates: number;
    totalSubordinates: number;
    name: string;
    subordinates: Subordinate[];
    rank?: Rank;
  };
}

export interface Domain {
  name: string;
  id: number;
  uid: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
}

export interface TreeUser {
  id: number;
  uid: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
  totalSubordinates: number;
  name: string;
}

export interface SubDepartment {
  name: string;
  id: number;
  uid: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
  heads: TreeUser[];
}

export interface Department {
  name: string;
  id: number;
  uid: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null | string;
  head: TreeUser;
  subDepartments: SubDepartment[];
}

export interface TreeInitialNodesResponseData {
  data: {
    name: string;
    id: number;
    uid: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: null | string;
    domain: Domain;
    managers: TreeUser[];
    departments: Department[];
  };
}

export interface QueryUsersWithTargetsDTO {
  name?: string;
  from: string;
  to: string;
}
